module.exports = {
  filename : "",
  quantities: [10, 25, 50, 100],
  report: {},
  offers: [],
  totals: [],
};
